import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, MessageCircle, Mail, MapPin, Instagram, Music2 } from "lucide-react";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  const phone = s.phone || "+234 813 977 1270";
  const wa = (s.whatsapp || phone).replace(/\D/g, "");

  return (
    <footer className="mt-24 border-t border-[#EAD9B0] bg-white" data-testid="site-footer">
      <div className="stripe-band h-1" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo.png" alt="" className="h-20 w-auto" />
            <div>
              <div className="font-display text-lg font-semibold">Jay's Veterinary</div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#0F766E] font-semibold">Consult &amp; Services</div>
            </div>
          </div>
          <p className="text-sm text-[#57534E] leading-relaxed">
            Professional veterinary care with <b>Dr. Juwon</b> — reliable, compassionate, evidence-based.
          </p>
        </div>

        <div>
          <div className="font-display text-base mb-4">Care</div>
          <ul className="space-y-2 text-sm text-[#57534E]">
            <li><Link to="/services" className="hover:text-[#0F766E]">Services</Link></li>
            <li><Link to="/consult" className="hover:text-[#0F766E]">Start a consultation</Link></li>
            <li><Link to="/book" className="hover:text-[#0F766E]">Book appointment</Link></li>
            <li><Link to="/shop" className="hover:text-[#0F766E]">Pet shop</Link></li>
            <li><Link to="/about" className="hover:text-[#0F766E]">Meet Dr. Juwon</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display text-base mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-[#57534E]">
            <li className="flex items-start gap-2"><Phone size={15} className="mt-0.5 text-[#0F766E]" /> {phone}</li>
            <li><a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-2 hover:text-[#0F766E]"><MessageCircle size={15} className="mt-0.5 text-[#25D366]" /> WhatsApp Dr. Juwon</a></li>
            {s.email ? <li className="flex items-start gap-2"><Mail size={15} className="mt-0.5 text-[#0F766E]" /> {s.email}</li> : null}
            {s.address ? <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#0F766E]" /> {s.address}</li> : null}
          </ul>
        </div>

        <div>
          <div className="font-display text-base mb-4">Hours &amp; Social</div>
          <ul className="space-y-2 text-sm text-[#57534E]">
            {s.hours ? <li className="whitespace-pre-line">{s.hours}</li> : <li className="text-[#57534E]">Configurable from admin dashboard</li>}
          </ul>
          <div className="flex gap-2 mt-4">
            {s.social_instagram && <a href={s.social_instagram} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#0F766E]/10 hover:bg-[#0F766E] hover:text-white transition-colors" data-testid="social-instagram" aria-label="Instagram"><Instagram size={16} /></a>}
            {s.social_tiktok && <a href={s.social_tiktok} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-[#0F766E]/10 hover:bg-[#0F766E] hover:text-white transition-colors" data-testid="social-tiktok" aria-label="TikTok"><Music2 size={16} /></a>}
          </div>
        </div>
      </div>

      <div className="border-t border-[#EAD9B0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-[#57534E]">
          <p>© {new Date().getFullYear()} Jay's Veterinary Consult and Services · Dr. Juwon (DVM, University of Ibadan)</p>
          <p className="text-[#7C2D12]"><strong>Emergency?</strong> Seek immediate veterinary attention at your nearest emergency facility.</p>
        </div>
      </div>
    </footer>
  );
}
